<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.$store.state.settings.dynamicTitle && this.$store.state.settings.title,
      titleTemplate: (title) => {
        return title ? `${title} - ${process.env.VUE_APP_TITLE}` : process.env.VUE_APP_TITLE
      }
    }
  }
}
</script>
<style>
.el-tooltip__popper {
  font-size: 14px;
  background: #f5f7fa !important;
  color: #303133 !important;
  max-width: 300px;
  border: 1px solid #e1e4eb;
}

.el-tooltip__popper[x-placement^='top'] .popper__arrow:after {
  border-top-color: #f5f7fa !important;
}

.attch_list.el-tooltip__popper[x-placement^='top'] .popper__arrow:after {
  border-top-color: #fff !important;
}

.attch_list.el-tooltip__popper[x-placement^='bottom'] .popper__arrow:after {
  border-bottom-color: #fff !important;
}

.attch_list.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: #e1e4eb !important;
}

.el-tooltip__popper[x-placement^='top'] .popper__arrow {
  border-top-color: #e1e4eb !important;
}
* {
  scrollbar-width: thin;
}
::-webkit-scrollbar {
  width: 8px; /*横向滚动条*/
  height: 8px; /* 纵向滚动条 必写*/
}

::-webkit-scrollbar-thumb {
  background-color: #cdd0d4;
  border-radius: 3px;
}
</style>
